module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vfcleg2-f90a5353eb7b68979fc1bc6f1fb34e55.jpg";